<template>
    <div>
        <pp-base-header-sec></pp-base-header-sec>
        <div class="container-fluid base-container">
            <div class="base-box p-normal">
                <b-form @submit.stop.prevent="onSubmit" @reset="onReset">
                    <div class="form-group form-group-sm">
                        <label for="titleQuery" class="form-label">Речи садржане у наслову</label>
                        <div class="input-group ">
                            <input id="titleQuery" v-model="form.titleQuery" type="text" class="form-control full-width">
                            <div class="input-group-append">
                                <div class="input-group-text">
                                    <input type="checkbox" v-model="form.titleMustOccur" class="mr-2" id="titleMustOccur">
                                    <label class="in-btn-form-label" for="titleMustOccur">
                                        Све ове речи
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group form-group-sm">
                        <label for="bodyQuery" class="form-label">Речи садржане у тексту</label>
                        <div class="input-group ">
                            <input id="bodyQuery" v-model="form.bodyQuery" type="text" class="form-control full-width">
                            <div class="input-group-append">
                                <div class="input-group-text">
                                    <input type="checkbox" v-model="form.bodyMustOccur" class="mr-2" id="bodyMustOccur">
                                    <label class="in-btn-form-label" for="bodyMustOccur">
                                        Све ове речи
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="spacer20"></div>
                    <div class="d-md-flex justify-content-between align-items-center">
                        <div class="form-group form-group-sm ">
                            <div class="form-inline ">
                                <label for="resultLimit" class="form-label mr-2">Величина резултата</label>
                                <select id="resultLimit" v-model="form.resultLimit" class="form-control">
                                    <option v-for="option in resultLimitOptions" v-bind:key="option" :value="option">
                                        {{ option }}
                                    </option>

                                </select>
                            </div>
                        </div>
                        <div class="form-group form-group-sm ">

                            <b-button type="submit" class="btn btn-base-submit text-uppercase mr-3"
                                v-if="canOpen === 'can_open'">
                                <span class="icon-search mr-2"></span>
                                Претрага
                            </b-button>
                            <button type="button" class="btn btn-base-submit text-uppercase mr-3"
                                v-if="canOpen === 'not_logged_in'" v-b-modal.login-modal href="#" @click.stop.prevent>
                                <span class="icon-search mr-2"></span>
                                Претрага
                            </button>
                            <button class="btn btn-base-submit text-uppercase mr-3" v-if="canOpen === 'role_not_allowed'"
                                @click.stop.prevent="role_not_allowed()">
                                <span class="icon-search mr-2"></span>
                                Претрага
                            </button>

                            <b-button type="reset" class="btn btn-base-reset text-uppercase">
                                <span class="icon-rotate-cw mr-2"></span>
                                Поништи све
                            </b-button>


                        </div>
                    </div>
                </b-form>
            </div>

            <result-counter v-if="searchResult !== null && this.userInfoState && this.userInfoState.roles.includes(this.$route.params.extCode)" 
                :count="searchResult.resultSize" :limit="searchResult.limit"></result-counter>

            <div v-if="searchResult && searchResult.result && searchResult.result.length && this.userInfoState && this.userInfoState.roles.includes(this.$route.params.extCode)"
                class="base-box base-box__table-sec">
                <b-table class="table-bootstrap-vue" striped bordered :items="searchResult.result" :fields="fields"
                    responsive="sm">
                    <template v-slot:cell(title)="data">
                        <router-link class="text-color-link"
                            v-if="userInfoState && data.item.act_type === 'REG' && data.item.has_html === 'False'"
                            :to="'/pppViewPdf/' + data.item.reg_db_id + '?doctype=' + data.item.act_type" target="_blank">
                            {{ data.item.title }}
                        </router-link>
                        <router-link class="text-color-link"
                            v-else-if="userInfoState && data.item.act_type === 'SLGLRS' && data.item.has_html === 'False'"
                            :to="'/pppViewPdf/' + data.item.guid_pdf_url + '?doctype=' + data.item.act_type" target="_blank">
                            {{ data.item.title }}
                        </router-link>
                        <router-link target="_blank" v-else-if="userInfoState" class="text-color-link"
                            :to="{ path: '/ppp/viewAct/' + data.item.id }">
                            {{ data.item.title }}
                        </router-link>
                        <a v-else class="text-color-link" target="_blank" @click.stop.prevent="openLoginModal()" href="#">
                            {{ data.item.title }}
                        </a>
                    </template>
                </b-table>
            </div>
        </div>
    </div>
</template>

<script>
import PpBaseHeaderSec from '@/base_pages/pp/PpBaseHeaderSec.vue';
import axios from 'axios';
import { mapState } from 'vuex';
import ResultCounter from '@/partials/ResultCounter.vue';


export default {
    name: "PpSearchPage",
    data() {
        return {
            fields: [
                { label: 'Назив', key: 'title', sortable: true },

            ],
            form: {
                titleQuery: null,
                titleMustOccur: true,
                bodyQuery: null,
                bodyMustOccur: true,
                resultLimit: 50,
            },
            resultLimitOptions: [50, 100, 200, 300, 400, 500],

            searchResult: null,
            searchFilter: null,

            // axios
            baseDIApiUrl: window.env.VUE_APP_API_DI_DEV,
            basePPPApiUrl: window.env.VUE_APP_API_PPP_DEV,
            meta: {
                title: 'Правно-информациони систем РС',
                description: 'Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.',
                keywords: 'zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik',
            },
        }
    },
    metaInfo() {
        return {
            title: this.meta.title,
            meta: [
                { name: 'title', content: this.meta.title },
                { name: 'description', content: this.meta.description },
                { name: 'keywords', content: this.meta.keywords },
            ],
        }
    },
    components: {
        PpBaseHeaderSec,
        ResultCounter
    },
    computed: {
        ...mapState(['userInfoState']),
        canOpen() {
            if (this.userInfoState) {
                if (this.userInfoState.roles.includes(this.$route.params.extCode)) {
                    return 'can_open';
                } else {
                    return 'role_not_allowed';
                }
            } else {
                return 'not_logged_in';
            }
        },
    },
    methods: {
        role_not_allowed() {
            alert('Немате приступ овој бази');
        },
        openLoginModal() {
            this.$root.$emit('bv::show::modal', 'login-modal', '#btnShow')
        },
        onSubmit(evt) {
            evt.preventDefault();
            this.search();
        },
        onReset(event) {
            this.searchResult = null;
            this.form = {
                titleQuery: null,
                titleMustOccur: true,
                bodyQuery: null,
                bodyMustOccur: true,
                resultLimit: 50,
            };
            event.preventDefault();
        },
        search() {
            const vm = this;
            axios.post(this.baseDIApiUrl + 'PPP/Search/' + this.$route.params.extCode, {
                tk: this.form.titleQuery,
                bk: this.form.bodyQuery,
                tmo: this.form.titleMustOccur,
                bmo: this.form.bodyMustOccur,
                limit: this.form.resultLimit,
            }).then(response => {
                this.searchResult = response.data;
            }).catch(function (error) {
                console.log(error);
                if (error.response.status === 401) {
                    // nije ulogovan
                    // otvori modal za logovanje
                    vm.$root.$emit('bv::show::modal', 'login-modal', '#btnShow')
                }
            });
        },
    },
    mounted() {
        const vm = this;
        // if (this.$route.query.q) {
        //     this.form.titleQuery = this.$route.query.q;
        //     this.search();
        // }
        if (this.userInfoState === undefined || this.userInfoState === null) {
            vm.$root.$emit('bv::show::modal', 'login-modal', '#btnShow');
            this.form.titleQuery = this.$route.query.q;
            this.search();

        } else if (this.userInfoState.roles.includes(this.$route.params.extCode)) {
            this.form.titleQuery = this.$route.query.q;
            this.search();
        }

    },
    beforeCreate: function () {
        document.body.className = 'color_ppp';
    }
}
</script>

<style scoped></style>
